import { addMessages } from '@hana/i18n';

// Khoá chuỗi opsc.* — mã nghiệp vụ không dịch.
addMessages('vi', {
  'opsc.1': "Bỏ lọc",
  'opsc.2': "Tổng quan kỳ",
  'opsc.3': "Theo loại phí",
  'opsc.4': "Tạm ứng · tài xế",
  'opsc.5': "Thử lại",
  'opsc.6': "Không có chuyến khớp lọc",
  'opsc.7': "Mở quyết toán",
  'opsc.8': "Chi phí",
  'opsc.9': "Duyệt",
  'opsc.10': "Bỏ chọn",
  'opsc.11': "Không có quyền xem số tiền.",
});
addMessages('en', {
  'opsc.1': "Clear filter",
  'opsc.2': "Period overview",
  'opsc.3': "By cost type",
  'opsc.4': "Advances · drivers",
  'opsc.5': "Retry",
  'opsc.6': "No trips match the filter",
  'opsc.7': "Open settlement",
  'opsc.8': "Costs",
  'opsc.9': "Approve",
  'opsc.10': "Deselect",
  'opsc.11': "You don't have permission to view amounts.",
});
